import { render, staticRenderFns } from "./ColorsForTextSection.vue?vue&type=template&id=f4f1e43c"
import script from "./ColorsForTextSection.vue?vue&type=script&lang=ts"
export * from "./ColorsForTextSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsForTextSection.vue?vue&type=style&index=0&id=f4f1e43c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports